// Featured Collection slider. Loaded once from the layout so every instance, including one
// added in the theme editor to a page that had none, is initialised from a single place.
(function () {
  const SECTION_SELECTOR = '.featured-collection';
  const SWIPER_SELECTOR = '.featured-collection__grid .swiper';

  function getConfig(section) {
    return {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
      pagination: {
        el: section.querySelector('.featured-collection__pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            ' swiper-pagination-bullet-custom">' +
            '0' +
            (index + 1) +
            '</span>'
          );
        },
        bulletClass: 'featured-collection__bullet',
        bulletActiveClass: 'featured-collection__bullet--active',
      },
    };
  }

  function findSections(scope) {
    const sections = Array.from(scope.querySelectorAll(SECTION_SELECTOR));
    if (scope.matches && scope.matches(SECTION_SELECTOR))
      sections.unshift(scope);
    return sections;
  }

  function init(scope) {
    if (typeof Swiper === 'undefined') return;

    findSections(scope).forEach(function (section) {
      const el = section.querySelector(SWIPER_SELECTOR);
      if (!el || el.swiper) return;
      new Swiper(el, getConfig(section));
    });
  }

  function destroy(scope) {
    findSections(scope).forEach(function (section) {
      const el = section.querySelector(SWIPER_SELECTOR);
      if (el && el.swiper) el.swiper.destroy(true, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
